import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { PortsStoreState } from '@navstation-portal/ports/data-model/ports';
import { signalStoreFeature } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { portEvents } from './ports-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withPortReducer<_>() {
  return signalStoreFeature(
    withTrackedReducer(
      on(
        portEvents.fetchPorts,
        (): Partial<PortsStoreState> => ({
          isFetchingPorts: true,
          fetchError: undefined,
        })
      ),
      on(
        portEvents.fetchPortsSuccess,
        ({ payload: ports }): Partial<PortsStoreState> => ({
          ports,
          isFetchingPorts: false,
        })
      ),
      on(
        portEvents.fetchPortsFailed,
        ({ payload: error }): Partial<PortsStoreState> => ({
          ports: [],
          isFetchingPorts: false,
          fetchError: error.message,
        })
      ),
      on(
        portEvents.clearPorts,
        (): Partial<PortsStoreState> => ({
          ports: [],
        })
      )
    )
  );
}
